import {Outlet, useNavigate} from 'react-router-dom';
import Modal from '../../components/modals';
import {globalUIContext, useGlobalUI} from '../../utils/global-ui-helpers';
import {SOCIAL_TABLES_TITLE} from '../../constants/page-title';
import './index.less';

const Root = () => {
  const globalUI = useGlobalUI();
  const navigate = useNavigate();
  return (
    <globalUIContext.Provider value={globalUI}>
      <div
        id="screen-reader-announcer"
        role="region"
        className="screen-reader-only"
        aria-live="assertive"
        aria-atomic="true"
      >
        Navigated to {SOCIAL_TABLES_TITLE}
      </div>
      <header className="header">
        <img
          id="st-logo"
          src="../../assets/images/logo.svg"
          onClick={() => navigate('/')}
          alt="socialtables logo"
          aria-label="Go back to the main page"
          tabIndex={0}
        />
      </header>
      <main className="main">
        <Outlet />
      </main>
      {globalUI?.modal?.modalName && <Modal />}
    </globalUIContext.Provider>
  );
};

export default Root;
